import { render, staticRenderFns } from "./fourRate.vue?vue&type=template&id=2f3be80f&scoped=true"
import script from "./fourRate.vue?vue&type=script&lang=js"
export * from "./fourRate.vue?vue&type=script&lang=js"
import style0 from "./fourRate.vue?vue&type=style&index=0&id=2f3be80f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3be80f",
  null
  
)

export default component.exports